<template>
    <validation-observer ref="form" v-slot="{ meta }">
        <modal
            @shown="setValues"
            :title="values.id ? 'Edit Calendar' : 'Create Calendar'"
            :ok-disabled="!meta.valid"
            :id="modalId"
            @ok.prevent="submit"
            :busy="busy"
        >
            <busy-modal :show="busy"></busy-modal>
            <validation-provider rules="required" name="country" v-slot="{ errors, handleChange }">
                <form-select
                    :options="countryOptions"
                    v-model="values.country"
                    label="Country"
                    :error="errors[0]"
                    @change="handleChange"
                />
            </validation-provider>
            <validation-provider rules="required" name="calendar_name" v-slot="{ errors, handleChange }">
                <form-input
                    label="Calendar Name"
                    v-model="values.calendar_name"
                    :error="errors[0]"
                    @input="handleChange"
                />
            </validation-provider>
        </modal>
    </validation-observer>
</template>

<script>
import api from '../../../api';
import { ADMIN_IMPORT_HOLIDAY_ENDPOINT } from '../../../endpoints';
import BusyModal from '../../generic/busy-modal/busy-modal.vue';

import FormInput from '../../generic/form-input/form-input.vue';
import FormSelect from '../../generic/form-select/form-select.vue';
import { formatResponseError } from '../../../utils/api';
import Modal from '../../generic/modal/modal.vue';

export default {
    components: {
        Modal,
        FormInput,
        FormSelect,
        BusyModal,
    },
    props: {
        initialValues: {
            type: Object,
            default: null,
        },
        modalId: {
            type: String,
            default: '',
        },
        busy: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            values: {
                calendar_name: '',
                country: 1,
            },
            countryOptions: [],
        };
    },
    methods: {
        submit() {
            this.$emit('submit', this.values);
        },
        async setValues() {
            await this.fetchCountries();
            this.values = this.initialValues || this.values;
            this.$refs.form.setValues(this.values);
        },
        async fetchCountries() {
            try {
                const { data } = await api.get(`${ADMIN_IMPORT_HOLIDAY_ENDPOINT()}country-list/`);
                this.countryOptions = data.map((item) => ({
                    value: item.id,
                    text: item.name,
                }));
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({
                    text: generic || 'Could not fetch countries.',
                });
            }
        },
    },
};
</script>

<style>
</style>